const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	strFormGroup: '.form-group',
	strInput: '.form-input',
	strLabel: '.form-label',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	classFocus: 'is-focused',
	classFilled: 'is-filled',
	classFadeOut: 'fade-out',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.rangeSlider();
		this.handleInputAnimation();
		this.preventNumTelInputsTypeLetters();
		this.preventNumberInputScroll();
		this.formatPhoneNumber();
		this.resetSelect2OnSubmit();
		this.resetInputLabelsOnSubmit();
		this.connectDateRangeValidation();
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		const scrollToTop = ($form) => {
			const popupContent = $form.closest('.fancybox-slide');
			const reachOutSection = $form.closest('.reach-out');

			if (popupContent.length) {
				// Scroll inside the popup itself
				popupContent.animate({
					scrollTop: 0
				}, 300);
			} else if (reachOutSection.length) {
				// Scroll to the error/response message within the reach-out section
				const $firstInvalid = $form.find('.wpcf7-not-valid').first();
				const $target = $firstInvalid.length ? $firstInvalid : $form.find('.wpcf7-response-output');

				if ($target.length) {
					$('html, body').animate({
						scrollTop: $target.offset().top - 150
					}, 'slow');
				}
			} else {
				// Scroll the full page
				$('html, body').animate({scrollTop: 0}, 'slow');
			}
		};

		const fadeOutMessage = () => {
			setTimeout(() => {
				$('.wpcf7-response-output').addClass(FormHelpers.classFadeOut);
			}, 4000);
		};

		const resetMessageState = () => {
			$('.wpcf7-response-output').removeClass(FormHelpers.classFadeOut);
		};

		document.addEventListener('wpcf7mailsent', (e) => {
			const $form = $(e.target); // current form that triggered event
			const $holder = $form.closest(formHolder);

			$holder.addClass(sentClass);
			resetMessageState();
			scrollToTop($form);
			fadeOutMessage();
			FormHelpers.resetSelect2OnSubmit();
			FormHelpers.resetInputLabelsOnSubmit();

			// If form is inside the popup, close popup after form submit
			if ($form.closest('.fancybox-slide').length) {
				setTimeout(() => {
					$.fancybox.close();
				}, 4000);
			}

			setTimeout(() => {
				$holder.removeClass(sentClass);
			}, delay);
		}, false);

		const errorEvents = ['wpcf7invalid', 'wpcf7spam', 'wpcf7mailfailed'];

		errorEvents.forEach((eventName) => {
			document.addEventListener(eventName, (e) => {
				const $form = $(e.target);
				resetMessageState();
				scrollToTop($form);
				fadeOutMessage();
			}, false);
		});
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	/**
	 * @description Connects date-from and date-to fields so that "to" can't be before "from"
	 */
	connectDateRangeValidation: function() {
		const $dateFrom = $('.js-form-date-from');
		const $dateTo = $('.js-form-date-to');

		if (!$dateFrom.length || !$dateTo.length) return;

		$dateFrom.on('change', function() {
			const fromVal = $(this).val();

			if (fromVal) {
				// Set min attribute on "to" field
				$dateTo.attr('min', fromVal);

				// If selected "to" date is before "from", reset it
				if ($dateTo.val() && $dateTo.val() < fromVal) {
					$dateTo.val('');
				}
			}
		});
	},

	rangeSlider() {
		const elRangeInputs = document.querySelectorAll('.range');

		function setProgress(elTarget) {
			const elRangeBar = elTarget.parentElement;
			const intThumbWidth = elRangeBar.clientHeight * 3;
			const intRangeBarWidth = elRangeBar.clientWidth - intThumbWidth;
			const intThumbWidthOffset = intThumbWidth / 2;
			const intProgressPosition = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
			const intRangePosition = (intRangeBarWidth * intProgressPosition) + intThumbWidthOffset;

			elRangeBar.style.background =
				'linear-gradient(to right, #5c92ff ' +
				intRangePosition + 'px, #e2e2ea ' +
				intRangePosition + 'px';
		}

		for (let i = 0; i < elRangeInputs.length; i++) {
			elRangeInputs[i].firstElementChild.addEventListener('input', function() {
				setProgress(this);
			});
			setProgress(elRangeInputs[i].firstElementChild);
		}
	},

	/**
	 * @description Animates labels on focus and when filling out the input/select fields
	 */
	handleInputAnimation: function() {
		$(FormHelpers.strInput).each(function() {
			FormHelpers.checkFilledState(this);
		});

		$(FormHelpers.strInput).on('focus', function() {
			$(this).closest(FormHelpers.strFormGroup).addClass(FormHelpers.classFocus);
		});

		$(FormHelpers.strInput).on('blur', function() {
			$(this).closest(FormHelpers.strFormGroup).removeClass(FormHelpers.classFocus);
			FormHelpers.checkFilledState(this);
		});

		// Select2 animation handling
		$('.js-select-form-group').each(function() {
			const $parent = $(this).closest(FormHelpers.strFormGroup);
			const select2Instance = $(this);

			function updateLabelState() {
				if (select2Instance.val()) {
					$parent.addClass(FormHelpers.classFilled);
				} else {
					$parent.removeClass(FormHelpers.classFilled);
				}
			}

			select2Instance.on('select2:open', function() {
				$parent.addClass(FormHelpers.classFocus);
			});

			select2Instance.on('select2:close', function() {
				$parent.removeClass(FormHelpers.classFocus);
				updateLabelState();
			});

			select2Instance.on('change', function() {
				updateLabelState();
			});

			updateLabelState(); // Ensure correct state on page load
		});
	},
	/**
	 * @description Checks if the input has a value and assigns a class if it does
	 * @param {HTMLElement} inputElement - The input field
	 */
	checkFilledState: function(inputElement) {
		const $parent = $(inputElement).closest(FormHelpers.strFormGroup);
		if ($(inputElement).val()) {
			$parent.addClass(FormHelpers.classFilled);
		} else {
			$parent.removeClass(FormHelpers.classFilled);
		}
	},

	preventNumTelInputsTypeLetters: function() {
		$('input[type="number"]').on('input', function() {
			const nonNumReg = /[^0-9]/g;
			$(this).val($(this).val().replace(nonNumReg, ''));
		});
		$('input[type="tel"]').on('input', function() {
			const nonNumReg = /[^0-9]/g;
			$(this).val($(this).val().replace(nonNumReg, ''));
		});
	},

	/**
	 * @description Prevent number input scroll using mouse wheel or keyboard arrows
	 */
	preventNumberInputScroll: function() {
		const numberInputs = document.querySelectorAll('input[type="number"]');

		numberInputs.forEach((input) => {
			// Prevent mouse wheel from changing input value
			input.addEventListener('wheel', function(e) {
				e.preventDefault();
			});
		});
	},

	/**
	 * @description Format phone number as 1-111-111-1111
	 */
	formatPhoneNumber: function() {
		$('input[type="tel"]').on('input', function() {
			let inputVal = $(this).val().replace(/[^0-9]/g, '');
			if (inputVal.length > 11) {
				inputVal = inputVal.substring(0, 11);
			}
			if (inputVal.length > 1) {
				inputVal = inputVal.replace(/^(\d)(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3-$4');
			}
			$(this).val(inputVal);
		});
	},

	/**
	 * @description Reset Select2 dropdowns after form submission
	 */
	resetSelect2OnSubmit: function() {
		$('.js-select-form-group').val(null).trigger('change');
	},

	/**
	 * @description Reset input labels to initial state after form submission
	 */
	resetInputLabelsOnSubmit: function() {
		$(FormHelpers.strInput).each(function() {
			const $parent = $(this).closest(FormHelpers.strFormGroup);
			$parent.removeClass(FormHelpers.classFocus).removeClass(FormHelpers.classFilled);
		});
	}
};

export default FormHelpers;
